<div class="flxClmn bs-enabled">
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container flxRow">
			<span class="page-title">Users &amp; Resources</span>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">
				Protected users, collaboration resources and how they connect
			</span>
		</div>
	</div>
	<div class="page-inner-content-holder gap-3 pt-0 flex-column no-scroll">
		<!--Tabs-->
		<div class="md-tabs" [ngStyle]="{'--md-tabs-width': tabWidth + 'px'}">
			<ng-container *ngFor="let tab of dic.CONSTANTS.collaborationProtectionUsersTabs | keyvalue: gs.returnZero">
				<div [ngClass]="{'selected' : gs.getTabName() === tab.value}"
					 [routerLink]="tab.value" queryParamsHandling="preserve">
					<input type="radio" name="tabs" id="{{tab.key}}Toggle" [checked]="gs.getTabName() === tab.value">
					<label for="{{tab.key}}Toggle">{{tab.value | camelCaseToTitleCase}}</label>
				</div>
			</ng-container>


			<div class="slide" [ngStyle]="{'left' : tabWidth * _.values(dic.CONSTANTS.collaborationProtectionUsersTabs).indexOf(gs.getTabName()) + 'px' || 0}"></div>
		</div>
		<!---->

		<router-outlet></router-outlet>
	</div>
</div>



